<template>
    <div class="app-container">
        <el-form :inline="true" :model="filters">
            <el-form-item  label="关键词">
                <el-input size="small" v-model="filters.search" placeholder="关键字"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" v-on:click="queryAll">查询</el-button>
                <el-button size="small" type="success" @click="handleCreate">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="mini" stripe border :data="tableData" highlight-current-row expand-on-click-node="false">
            <el-table-column prop="Name" label="奖品名称" min-width="120">
            </el-table-column>
            <el-table-column prop="Price" label="奖品价值" width="100">
            </el-table-column>
            <el-table-column prop="Count" label="发行数量" width="100">
            </el-table-column>
            <el-table-column prop="BeginDate" label="有效起期" width="100">
                 <template slot-scope="scope">
                    {{ format.dateFormat(scope.row.BeginDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="EndDate" label="有效止期" width="100">
                 <template slot-scope="scope">
                    {{ format.dateFormat(scope.row.EndDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="Logo" label="图片" width="100">
        <template slot-scope="scope">
          <viewer v-if="scope.row.Logo">
            <img
              v-if="scope.row.Logo"
              :src="baseUrl + scope.row.Logo"
              :key="scope.row.Logo"
              style="height: 40px"
            />
          </viewer>
        </template>
      </el-table-column>
            <el-table-column prop="Description" label="兑奖说明" min-width="120">
            </el-table-column>
            <el-table-column sortable prop="InsertTime" label="创建时间" width="120">
                <template slot-scope="scope">
                    {{ format.dateTimeFormat(scope.row.InsertTime) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="pageSizesList" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total" :current-page.sync="pageIndex"></el-pagination>
        </div>
        <awardEditor ref="awardEditor" @update="queryAll"/>
    </div>
</template>
<script>
import { getPageList, Delete } from "@/api/activity/award";
import awardEditor from "./components/awardEditor.vue";
export default {
    components: {
        awardEditor,
    },
    data() {
        return {
            filters: {
                search: ""
            },
            tableData: [],
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            pageSizesList: [10, 15, 20, 30, 50],
        };
    },
    methods: {
        queryAll() {
            let para = {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                search: this.filters.search,
            };
            getPageList(para).then((response) => {
                if (response) {
                    this.tableData = response.Items;
                    this.total = response.Total || response.Items.length;
                }
            });
        },
        handleCreate() {
            this.$nextTick(() => {
                this.$refs["awardEditor"].handleCreate();
            });
        },
        handleUpdate(row) {
            this.$nextTick(() => {
                this.$refs["awardEditor"].handleUpdate(row);
            });
        },
        //删除
        handleDelete: function (row) {
            this.$confirm("确认删除该跑团吗?", "提示", {
                type: "warning",
            }).then(() => {
                let para = { key: row.Key };
                Delete(para).then((response) => {
                    if (response) {
                        this.msg.successMsg("操作成功");
                        this.queryAll();
                    }
                });
            });
        },
        handleSizeChange(val) {
            var pageSize = `${val}`;
            this.pageIndex = 1;
            this.pageSize = parseInt(pageSize);
            this.$nextTick(() => this.queryAll());
        },

        handleCurrentChange(val) {
            this.pageIndex = `${val}`;
            this.queryAll();
        },
    },
    mounted() {
        this.queryAll();
    },
};
</script>